import { BadgeCheck, Accessibility, Phone, MessageCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { REASONS, CONTACT, waLink, DEFAULT_WA_MESSAGE } from "@/data/content";

export const NedenBiz = () => (
  <section id="neden-biz" className="scroll-mt-24 bg-slate-50 py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
        <Reveal>
          <div className="lg:sticky lg:top-28">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand">Neden Biz?</p>
            <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Sürprizsiz süreç, özenli işçilik
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-slate-600">
              Müşterilerimizin yorumlarında en çok öne çıkan değerlerimizle fark yaratıyoruz.
            </p>

            <div className="mt-8 flex flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-6 shadow-soft sm:flex-row sm:items-center">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-softer text-brand">
                <Accessibility className="h-5 w-5" />
              </span>
              <p className="text-sm leading-relaxed text-slate-600">
                <span className="font-bold text-slate-900">Herkes için erişilebilir:</span> tekerlekli
                sandalyeye uygun girişimiz ve engelli otoparkımız mevcuttur.
              </p>
            </div>

            <div className="mt-4 flex flex-col gap-3 sm:flex-row">
              <a
                href={CONTACT.phoneHref}
                data-testid="neden-biz-call-btn"
                className="inline-flex flex-1 items-center justify-center gap-2 rounded-full border border-slate-300 bg-white px-6 py-3.5 text-sm font-bold text-slate-800 transition-all hover:border-brand hover:text-brand"
              >
                <Phone className="h-4 w-4" />
                {CONTACT.phoneDisplay}
              </a>
              <a
                href={waLink(DEFAULT_WA_MESSAGE)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="neden-biz-whatsapp-btn"
                className="inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-whatsapp px-6 py-3.5 text-sm font-bold text-white transition-all hover:bg-whatsapp-dark"
              >
                <MessageCircle className="h-4 w-4" />
                WhatsApp'tan Yaz
              </a>
            </div>
          </div>
        </Reveal>

        <div className="grid gap-6 sm:grid-cols-2">
          {REASONS.map((r, i) => (
            <Reveal key={r.title} delay={(i % 2) * 0.1}>
              <div
                data-testid={`reason-card-${i + 1}`}
                className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:border-brand/50 sm:p-7"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand text-white shadow-soft">
                  <BadgeCheck className="h-5 w-5" />
                </span>
                <p className="mt-5 font-condensed text-sm font-bold tracking-[0.2em] text-brand">
                  0{i + 1}
                </p>
                <h3 className="mt-1.5 font-display text-lg font-bold leading-snug text-slate-900">
                  {r.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-slate-600">{r.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default NedenBiz;
